<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_PORTL')" :vertical="false"/>
          </div>
          <div class="col-xs-5">
            <!--<sui-code-select :selected="selectedCode" codeId="" />-->
            <sui-custom-select ref="comboPortals"
                           :selected="frame0.selectData.portals"
                           :option-list="frame0.selectPortalList"
                           :initialSelectedIndex="0"
                           :defaultOption="'all'"
                           @selection-changed="onLoadPortalSelect"
                           @list-clicked="onPortalSelectClick"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_APPLICATION')" :vertical="false"/>
          </div>
          <div class="col-xs-5">
            <sui-custom-select ref="comboApps"
                           :selected="frame0.selectData.apps"
                           :option-list="frame0.selectAppList"
                           :initialSelectedIndex="0"
                           :defaultOption="'select'"
                           :disabled="disableSelectApps"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_QLINK_MARK_NM')" :vertical="false"/>
          </div>
          <div class="col-xs-5">
            <sui-text-field ref="searchText"
                            v-model="frame0.selectData.searchText"
                            @keyup.enter="onSearchClick"
                            maxlength="50"
                            placeholder=""
            >
            </sui-text-field>
          </div>
        </div>
        <div class="btn_wrap">
            <sui-button
                type="button"
                class="comm_btn_Reset"
                @click="onResetClick">{{ $t('MSG_BTN_RESET') }}</sui-button>
            <sui-button
                v-permission:read="this.$options.name"
                type="button"
                class="comm_btn_Scr"
                @click="onSearchClick">{{ $t('MSG_BTN_SEARCH') }}</sui-button>
        </div>
      </div>
      <div class="mrB10"/>
      <sui-grid
        ref="mainGrid"
        :columns="gridColumns0"
        :dataset="'dsQLinkList'"
        @rowselect="onRowSelect"
        :showCountControl="true"
        :showDisplayCountControl="false"
       >
        <div class="comp_spacing"></div>
         <div class="btn_wrapL">
           <sui-button
               v-permission:read="this.$options.name"
               type="button"
               class="comm_btn_gridTop"
               @click="onReOrderClick">{{ $t('MSG_TXT_RE_ORDER') }}</sui-button>
         </div>
      </sui-grid>
      <div class="mrB30" />
      <sui-page-tab-box-type
        ref="tab"
        :tabItems="tabItems"
        :defaultTabIndex="defaultTabIndex"
        :setCurrentTabComponent="setCurrentTabComponent"
        @change-tab-idx="onChangeTabIdx"
      >
        <container
            ref="tabPage"
            :is="currentTabComponent"
            :selectedGridRowData="selectedGridRowData"
            :pageId="$options.name"
            @onClearSelectionMainGrid="onClearSelectionMainGrid"
            @onSearchClick="onSearchClick"
            @page-deactivate="handleChildDeactivated"
            @page-activate="handleChildActivated"
        />
      </sui-page-tab-box-type>

      <sui-popup
          v-model="showPopup"
          :title="popTitle"
      >
        <p01
            :pageId="$options.name"
            :portalId="frame0.selectData.apps.key"
            @reorder-cancel="onPopupCancel"
            @reorder-save="onPopupSave"
        />
      </sui-popup>
    </sui-page-contents>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';
import tab01 from './components/PGE_CMP_00015_T01';
import p01 from './components/PGE_CMP_00015_P01';

const userDataFields = ['userId', 'loginId', 'dsplLngId', 'knoxId', 'userName',
  'userGlobalName', 'departmentName', 'departmentEnglishName'];

export default {
  name: 'PGE_CMP_00015', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  components: {
    tab01,
    p01,
  },
  data() {
    return {
      codes: CommonConstants.selectOptions(),
      disableSelectApps: true,
      selectedGridRowData: {},
      currentTabComponent: 'tab01',
      defaultTabIndex: 0,
      tabItems: [
        {
          tabTitle: this.$t('MSG_TXT_QLINK'), // '퀵링크'
          tabComponent: tab01,
        },
      ],
      showPopup: false,
      popTitle: this.$t('MSG_TXT_RE_ORDER'),
      frame0: {
        selectData: {
          portals: {},
          apps: {},
          COD_APP_SEARCH_COND: {
            label: this.$t('MSG_TXT_ALL'),
            key: 'ALL',
          },
          searchText: '',
        },
        selectPortalList: [],
        selectAppList: [],
      },

      localdata0: [],
      gridColumns0: [{
        text: 'Portal',
        datafield: 'portalName',
        width: '100',
      }, {
        text: this.$t('MSG_TXT_APPLICATION_NM'),
        datafield: 'applicationName',
        width: '200',
      }, {
        text: this.$t('MSG_TXT_QLINK_NM'),
        datafield: 'quickLinkName',
      }, {
        text: this.$t('MSG_TXT_MDFC_USR'),
        datafield: 'finalModificationUserId',
        width: '200',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
            displayType: '1',
            type: 'link',
            datafieldMap: {
              displayLanguageId: 'm_dsplLngId',
              userId: 'm_userId',
              knoxId: 'm_knoxId',
              userName: 'm_userName',
              userGlobalName: 'm_userGlobalName',
              departmentName: 'm_departmentName',
              departmentEnglishName: 'm_departmentEnglishName',
              loginId: 'm_loginId',
            },
          }, this.dsQLinkList, this.$refs.mainGrid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_MDFC_DTM'),
        datafield: 'finalModificationDTM',
        width: '150',
        createwidget: (r, c, v, h) => utils.getGridCellFactory().createCellDateLabel(r, c, v, h, this.dsQLinkList, this.$refs.mainGrid),
        initwidget: (r, c, v, h) => utils.getGridCellFactory().refreshCell(r, c, v, h),        
      }],
    };
  },
  datasets: [{
    id: 'dsQLinkList',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { name: 'portalId', type: 'string', map: 'portalId' },
      { name: 'portalName', type: 'string', map: 'portalName' },
      { name: 'applicationName', type: 'string', map: 'applicationName' },
      { name: 'applicationId', type: 'string', map: 'applicationId' },
      { name: 'quickLinkUid', type: 'string', map: 'quickLinkUid' },
      { name: 'quickLinkName', type: 'string', map: 'quickLinkName' },
      { name: 'quickLinkMultiLanguageId', type: 'string', map: 'quickLinkMultiLanguageId' },
      { name: 'quickLinkMultiLanguageName', type: 'string', map: 'quickLinkMultiLanguageName' },
      { name: 'quickLinkUrl', type: 'string', map: 'quickLinkUrl' },
      { name: 'quickLinkEnglishUrl', type: 'string', map: 'quickLinkEnglishUrl' },
      { name: 'arrayalOrder', type: 'string', map: 'arrayalOrder' },
      { name: 'firstRegistrationUserId', type: 'string', map: 'firstRegistrationUserId' },
      { name: 'firstRegistrationDTM', type: 'string', map: 'firstRegistrationDTM' },
      { name: 'finalModificationUserId', type: 'string', map: 'finalModificationUserId' },
      { name: 'finalModificationDTM', type: 'string', map: 'finalModificationDTM' },
      { type: 'string', name: 'r_dsplLngId', map: 'r_dsplLngId' },
      { type: 'string', name: 'r_userId', map: 'r_userId' },
      { type: 'string', name: 'r_loginId', map: 'r_loginId' },
      { type: 'string', name: 'r_knoxId', map: 'r_knoxId' },
      { type: 'string', name: 'r_userName', map: 'r_userName' },
      { type: 'string', name: 'r_userGlobalName', map: 'r_userGlobalName' },
      { type: 'string', name: 'r_departmentName', map: 'r_departmentName' },
      { type: 'string', name: 'r_departmentEnglishName', map: 'r_departmentEnglishName' },
      { type: 'string', name: 'm_dsplLngId', map: 'm_dsplLngId' },
      { type: 'string', name: 'm_userId', map: 'm_userId' },
      { type: 'string', name: 'm_loginId', map: 'm_loginId' },
      { type: 'string', name: 'm_knoxId', map: 'm_knoxId' },
      { type: 'string', name: 'm_userName', map: 'm_userName' },
      { type: 'string', name: 'm_userGlobalName', map: 'm_userGlobalName' },
      { type: 'string', name: 'm_departmentName', map: 'm_departmentName' },
      { type: 'string', name: 'm_departmentEnglishName', map: 'm_departmentEnglishName' },
    ],
  }],
  mounted() {
    this.dsQLinkList.$on(this.dsQLinkList.EVENTS.SELECTION_CHANGED, this.onRowSelect);
    this.getPortalList();
    // this.getApplicationList();
  },
  beforeDestroy() {
    this.dsQLinkList.$off(this.dsQLinkList.EVENTS.SELECTION_CHANGED, this.onRowSelect);
  },
  methods: {
    getPortalList() {
      http.request(this.$options.name, 'DTS_CMP_00004')
        .then(res => {
          utils.forEach(res.data, obj => {
            this.frame0.selectPortalList.push({
              key: obj.portalId,
              label: obj.portalName,
            });
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    getApplicationList(vPortal) {
      // Application list
      http.request(this.$options.name, 'DTS_CMP_00005', {
        query: {
          portalId: utils.trim(vPortal.key),
        },
      })
        .then(res => {
          this.frame0.selectAppList.splice(0);
          utils.forEach(res.data, obj => {
            this.frame0.selectAppList.push({
              key: obj.applicationId,
              label: obj.applicationName,
            });
          });
          this.frame0.selectData.apps = {};
        })
        .catch(error => {
          console.log(error);
        });
    },
    onChangeTabIdx(idx) {
      this.currentTabComponent = this.tabItems[idx].tabComponent;
    },
    setCurrentTabComponent(component) {
      this.currentTabComponent = component;
    },
    onRowSelect() {
      this.selectedGridRowData = utils.getSelectedRow(this.dsQLinkList);
    },
    onClearSelectionMainGrid() {
      // this.$refs.mainGrid.clearselection();
      this.dsQLinkList.clearSelection();
    },
    onPortalSelectClick() {
      this.getApplicationList(this.frame0.selectData.portals);
      this.disableSelectApps = this.frame0.selectData.portals.key === 'ALL';
    },
    onLoadPortalSelect() {
      this.getApplicationList(this.frame0.selectData.portals);
    },
    onResetClick() {
      // this.selectedGridRowData = {};
      this.frame0.selectData.searchText = '';
      this.$refs.comboPortals.reset();
      this.$refs.comboApps.reset();
      this.disableSelectApps = true; // 비활성화
    },
    onSearchClick() {
      const searchValue = this.frame0.selectData;
      const queryParams = {
        portalId: utils.trim(searchValue.portals.key) || '',
        applicationId: utils.trim(searchValue.apps.key) || '',
        searchText: utils.trim(searchValue.searchText) || '',
      };
      http.request(this.$options.name, 'DTS_CMP_00045', {
        query: queryParams,
      }).then(res => {
        this.localdata0 = res.data;

        this.dsQLinkList.setRawData(this.setUserInfoFormat(res.data));
      }).catch(error => {
        console.log(error);
      });
    },
    setUserInfoFormat(list) {
      utils.forEach(list, data => {
        const result = {};
        utils.forEach(data.firstRegistrationUserInfo, (value, key) => {
          if (utils.indexOf(userDataFields, key) !== -1) {
            result[`r_${key}`] = value;
          }
        });
        utils.forEach(data.finalModificationUserInfo, (value, key) => {
          if (utils.indexOf(userDataFields, key) !== -1) {
            result[`m_${key}`] = value;
          }
        });
        if (!utils.isEmpty(result)) {
          utils.assign(data, result);
        }
      });
      return list;
    },
    onReOrderClick() {
      this.showPopup = true;
    },
    onPopupCancel() {
      this.showPopup = false;
    },
    onPopupSave() {
      this.showPopup = false;
      this.onSearchClick();
    },
  },
};
</script>
<style scoped>
</style>
